import { PageLocatorMap } from '../types/PageLocatorMap';

export const applicantEmploymentDetailsPage = {
  alert: {
    error: 'applicant-employment-details-page.form.alert.error',
  },
  footer: {
    root: 'applicant-employment-details-page.footer.root',
  },
  form: {
    employerNameInput:
      'applicant-employment-details-page.form.employer-name-input',
    employerNameInputError:
      'applicant-employment-details-page.form.employer-name-input-error',
    grossAnnualIncomeInput:
      'applicant-employment-details-page.form.gross-annual-income-input',
    grossAnnualIncomeInputError:
      'applicant-employment-details-page.form.gross-annual-income-input-error',
    h1: 'applicant-employment-details-page.form.h1',
    h2: 'applicant-employment-details-page.form.h2',
    jobTitleInput: 'applicant-employment-details-page.form.job-title-input',
    jobTitleInputError:
      'applicant-employment-details-page.form.job-title-input-error',
    root: 'applicant-employment-details-page.form.root',
    submitButton: 'applicant-employment-details-page.form.submit-button',
  },
} as const satisfies PageLocatorMap;
